// types
import type { GddsSidebarProps } from '../locator.types';

// components
import Sidebar from './Sidebar';
import GDDSSidebar from './GDDSSidebar';

// utils
import { useNord } from 'utils/hooks/use-nord';

export function SidebarWrapper(props: Readonly<GddsSidebarProps>) {
  const isNord = useNord();

  if (isNord) {
    return <GDDSSidebar {...props} />;
  }

  return <Sidebar {...props} />;
}
